import { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import './PaymentModal.css'

export default function PaymentModal({ open, onClose, clientSecret, price, email }) {
    const stripe = useStripe()
    const elements = useElements()

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    if (!open) return null

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!stripe || !elements) return

        setLoading(true)
        setError('')

        const result = await stripe.confirmPayment({
            elements,
            redirect: 'if_required',
            //redirect: 'always', // USE THIS FOR TESTING
            confirmParams: {
                // attach the email so it is present in the return url
                // otherwise the billing page will want to re-auth
                return_url: `${window.location.origin}/billing-success?email=${encodeURIComponent(email)}`,

                payment_method_data: {
                    // Need to provide the country code since
                    // country is inhibited from display
                    billing_details: {
                        address: {
                            country: 'UK',
                        }
                    }
                }
            },
        })

        if (result.error) {
            setError(result.error.message || 'Payment failed')
        } else {
            window.alert("You have successfully subscribed.")

            onClose("Subscribe Successful")
        }

        setLoading(false)
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>

                <button className="modal-close" onClick={onClose}>
                    ✕
                </button>

                {!clientSecret ? (
                    <div>Loading payment form...</div>
                ) : (
                    <form onSubmit={handleSubmit} className="stripe-form">
                        <PaymentElement
                            options={{
                                fields: {
                                    billingDetails: {
                                        address: {
                                            country: 'never'
                                        }
                                    }
                                }
                            }}  />

                        {error && <p className="billing-error">{error}</p>}
                        <p style={{ textAlign: "center", padding: "10px" }}>
                            {price}
                        </p>
                        <button
                            type="submit"
                            disabled={loading || !stripe}
                            className="stripe-pay-button"
                        >
                            {loading ? 'Processing...' : 'Pay now'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    )
}
